export const POST_FUEL_CONSUMPTION_REPORT_PER_DRIVER = 'POST_FUEL_CONSUMPTION_REPORT_PER_DRIVER';
export const CLEAR_FUEL_CONSUMPTION_REPORT_PER_DRIVER = 'CLEAR_FUEL_CONSUMPTION_REPORT_PER_DRIVER';
export const FLAG_FUEL_CONSUMPTION_REPORT_PER_DRIVER_ACTIVITY =
    'FLAG_FUEL_CONSUMPTION_REPORT_PER_DRIVER_ACTIVITY';